/**
 * Switch to selected page.
 */
function switch_page() {

    if (!!document.querySelector('.nav_content_mobile')) {

        let switcher = document.querySelector('.nav_ul_menu_mobile a:first-child');
        let links = document.querySelectorAll('.nav_ul_menu_mobile a');

        if (switcher != null) {
            switcher.addEventListener("click", (e) => {
                e.preventDefault();

                if (links != null) {
                    links.forEach((link) => {
                        link.classList.toggle("show");
                    });
                }
            });
        }

    }
}

switch_page();

export default switch_page;